module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a4b63c1ef33148c23143a457fdc45bfc.png";